<template>
  <div>
    <div class="logo-box">
      <img
        class="logo"
        src="@/assets/images/fordays-transparent.png"
        alt="Fordays"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "FordaysBannerLogo",
};
</script>
<style scoped>
.logo-box {
  text-align: center;
}
.logo {
  max-width: 220px;
}
</style>